import React, { FC } from 'react';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { createRandomKey } from '../../utils/jsxUtils';
import { CommentaryHeader } from './CommentaryHeader';
import { CommentarySubtext } from './CommentarySubtext';

import { PaperCommentary } from '../commentary.types';

type Props = {
  commentary: PaperCommentary;
  className?: string;
  small?: boolean;
};

export const PaperCommentaryCard: FC<Props> = ({
  commentary,
  className,
  small = false,
}) => {
  const id = `access-paper-${createRandomKey()}`;
  return (
    <div
      className={className}
      data-for={id}
      data-tip
      data-offset="{'top': -20}"
    >
      <CommentaryHeader commentary={commentary} small={small} />
      <CommentarySubtext commentary={commentary} />
      <Tooltip effect="solid" place="top" id={id}>
        <div>
          <FormattedMessage id="commentary/card/PaperCommentaryCard.tsx/1" />
        </div>
      </Tooltip>
    </div>
  );
};
